import {css} from '@emotion/react'
import {useAiContext} from './AiContext.mjs'
import {DraftFiles} from './DraftFiles.jsx'
import {DraftText} from './DraftText.jsx'
import {DraftTools} from './DraftTools.jsx'

const cssDraft = css({
    '--border-radius': '24px',
    '--gap': '12px',
    border: '1px solid rgb(243, 244, 246)',
    borderRadius: 'var(--border-radius)',
    overflow: 'hidden',
})

const cssDraftCompact = css({
    '--border-radius': '8px',
    '--gap': '8px',
})

const cssFiles = css({
    maxHeight: 200,
    backgroundColor: '#fff',
    padding: 12,
    borderRadius: 'inherit',
    overflowY: 'auto',

    '&:empty': {
        display: 'none',
    },
})

const cssText = css({
    backgroundColor: 'rgb(243, 244, 246) !important',
    padding: 'var(--gap)',
    borderTopLeftRadius: 'var(--border-radius)',
    borderTopRightRadius: 'var(--border-radius)',
})

const cssTools = css({
    backgroundColor: 'rgb(243, 244, 246)',
    padding: 'var(--gap)',
    paddingTop: 0,
})

export const Draft = ({tools, ...props}) => {
    const ai = useAiContext()

    return (
        <div
            css={[cssDraft, ai.compactView && cssDraftCompact]}
            {...props}
        >
            <DraftFiles css={cssFiles} />
            <DraftText css={cssText} />
            <DraftTools css={cssTools} tools={tools}/>
        </div>
    )
}
